import React from 'react';
import number_format from './number-format.jsx';
import us_states from './us_states.js';

class MemberForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  render() {
    const props = this.props;
    const renewal = props.renewal;
    const member_loaded = props.memberLoaded;
    const plan_title = props.title;
    const plan_price = props.price;
    const final_price = props.final_price;
    const is_special_member = false;
    const show_dob = props.show_dob;
    const is_business_plan = props.is_business_plan;
    const plan_id = props.id;
    const member_code = props.member_code;
    const zip_code = props.zip_code;
    const home_club = props.home_club;
    const before121 = props.before121;
    const year = (new Date()).getFullYear();
    let courses = {
      'srgc': 'Scotland Run',
      'bgc': 'Ballamor'
    };
    if (home_club && home_club.indexOf) {
        for (var c in courses) {
            if (home_club.indexOf(c) === -1) {
                delete courses[c];
            }
        }
    }
    const course_ids = Object.keys(courses);
    const plans = props.plans;

    return <div className="membership-app-section is-active" id="ma-member">
      <h2 className="section-title">Membership {renewal ? 'Renewal' : 'Application'}</h2>
      {!renewal ?
      <h3 className="section-subtitle">
          <strong className="plan-name">{plan_title}</strong> - <span className="plan-price">${final_price}</span>
      </h3> : null}
      <br />
      <div className="section-content">
        <div id="ma-member-form" className="section-form" action="" method="post" data-show-dob={show_dob ? '1' : '0'} data-is-business={is_business_plan ? '1' : '0'}>
            <input type="hidden" name="member[plan_nid]" defaultValue={plan_id} />
            <input type="hidden" name="member[plan]" defaultValue={plan_title} />
            {renewal ?
            <div>
              <fieldset id="ma-member-renewal-info" style={is_special_member ? { display: 'none' } : {}}>
                  <p style={{ 'textAlign': 'center' }}>Enter your Member ID and Zip Code to load your membership information.</p>
                  <div className="row">
                      <div className="col-md-4 col-md-offset-2">
                          <div className="form-group">
                              <label htmlFor="member_id">Member ID:</label>
                              <div className="form-control-wrapper">
                                  <input type="text" className="form-control" name="member[id]" id="renewal_member_id" maxLength={5} required value={member_code} />
                                  <small className="help-block"><span tabIndex="-1" data-toggle="tooltip" data-placement="bottom" title="To retrieve your member ID, please refer to your invoice that was mailed to you. Additionally, you may email membership@ottingergolf.com or call any of the golf shops.">How to find it?</span></small>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-4">
                          <div className="form-group">
                              <label htmlFor="member_zipcode">Zip Code:</label>
                              <input type="text" className="form-control" id="renewal_member_zipcode" pattern="[0-9]*" maxLength={5} required value={zip_code} />
                          </div>
                      </div>
                  </div>
              </fieldset>
              <h3 className="payment-already-processed-block hidden-block">
                  <div className="text-center">Payment already processed.</div>
              </h3>
              <h3 className="plan-change-block section-subtitle hidden-block">
                  <strong className="plan-name">{plan_title}</strong> - <span className="plan-price">${plan_price} <small>+ 6.625% tax</small></span>
                  <div id="ma-change-plan" className="plan-change">
                      <a className="js-change-plan-toggle">Change Plan</a>
                      <div className="row js-change-plan-wrapper hidden-block">
                          <div className="col-sm-8">
                              <div className="form-group">
                                  <select className="form-control js-change-plan-select">
                                    <option value="">Available Plans</option>
                                    {plans.sort((a, b) => {
                                        if (a.title < b.title) {
                                            return -1;
                                        } else {
                                            return 1;
                                        }
                                    }).map((plan, index) => {
                                        if (!plan.golf_plan_is_available_for_renewal) {
                                          return null;
                                        }
                                        if (plan.is_business_plan) {
                                          return null;
                                        }
                                        let new_plan_price_raw = plan.price;
                                        let new_plan_price_request = number_format(new_plan_price_raw, 2, ".", "");
                                        let new_plan_price_discounted = new_plan_price_request;
                                        let new_plan_discount = plan.discount;
                                        if (new_plan_discount) {
                                            new_plan_price_discounted = number_format(new_plan_price_raw - new_plan_discount, 2, ".", "");
                                        }
                                        return <option 
                                            key={plan.id}
                                            value={plan.id}
                                            data-id={plan.id}
                                            data-name={plan.title}
                                            data-discount={new_plan_discount}
                                            data-price={new_plan_price_request}
                                            data-price-discounted={new_plan_price_discounted}
                                            data-taxable-amount={plan.taxable_amount}
                                            >
                                            {plan.title}
                                        </option>
                                    })}
                                  </select>
                              </div>
                          </div>
                          <div className="col-sm-4">
                              <button type="button" className="button button-primary button-small button-block js-change-plan">Change</button>
                          </div>
                      </div>
                  </div>
              </h3>
            </div> : null}
            <fieldset className={"member-info-block" + (renewal ? " hidden-block" : '')} id="ma-member-info">
                <div className="row">
                    <div className="col-md-5">
                        <div className="form-group">
                            <label htmlFor="member_first_name">First Name:</label>
                            <div className="form-control-wrapper">
                                <input type="text" className="form-control" name="member[first_name]" id="member_first_name" required />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label htmlFor="member_middle_name">Middle Initial:</label>
                            <div className="form-control-wrapper">
                                <input type="text" className="form-control" name="member[middle_name]" id="member_middle_name" />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="form-group">
                            <label htmlFor="member_last_name">Last Name:</label>
                            <div className="form-control-wrapper">
                                <input type="text" className="form-control" name="member[last_name]" id="member_last_name" required />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="member_address">Home Address:</label>
                    <div className="form-control-wrapper">
                        <input type="text" className="form-control" name="member[address]" id="member_address" required />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="member_city">City:</label>
                            <div className="form-control-wrapper">
                                <input type="text" className="form-control" name="member[city]" id="member_city" required />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="member_state">State:</label>
                            <div className="form-control-wrapper">
                                <select className="form-control" name="member[state]" id="member_state" required>
                                    <option key="0" value=""></option>
                                    {Object.keys(us_states).map((k) => {
                                        return <option key={k} value={k}>{us_states[k]}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label htmlFor="member_zipcode">Zip Code:</label>
                            <div className="form-control-wrapper">
                                <input type="text" className="form-control" name="member[zipcode]" pattern="[0-9]*" maxLength={5} id="member_zipcode" required />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label htmlFor="member_phone">Phone:</label>
                            <div className="form-control-wrapper">
                                <input type="tel" className="form-control phone_us" name="member[phone]" id="member_phone" required />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="form-group">
                            <label htmlFor="member_email">Email:</label>
                            <div className="form-control-wrapper">
                                <input type="email" className="form-control" name="member[email]" id="member_email" required />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12 hidden-block" id="ma-date-of-birth">
                        <div className="form-group" style={{ maxWidth: '500px' }}>
                            <label htmlFor="member_birthday_month">Date of Birth:</label>
                            <div className="form-control-wrapper">
                                <select className="form-control" name="member[birthday][month]" id="member_birthday_month" placeholder="Month" required>
                                    <option value="">Month</option>
                                    {Array(12).fill().map((_, i) => {
                                      return <option key={i} value={i+1}>{i+1}</option>
                                    })}
                                </select>
                            </div>
                            <label className="text-center" style={{ minWidth: 20, marginRight: 0 }}>/</label>
                            <div className="form-control-wrapper">
                                <select className="form-control" name="member[birthday][day]" id="member_birthday_day" placeholder="Day" required>
                                    <option value="">Day</option>
                                    {Array(31).fill().map((_, i) => {
                                      return <option key={i} value={i+1}>{i+1}</option>
                                    })};
                                </select>
                            </div>
                            <label className="text-center" style={{ minWidth: 20, marginRight: 0 }}>/</label>
                            <div className="form-control-wrapper">
                                <select className="form-control" name="member[birthday][year]" id="member_birthday_year" placeholder="Year" required>
                                    <option value="">Year</option>
                                    {Array(80).fill().map((_, i) => {
                                      return <option key={i} value={year-(80-i)}>{year-(80-i)}</option>
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    {course_ids.length === 1
                        ? <input type="hidden" name="member[home_club]" readOnly={true} className="js-home-club" value={course_ids[0]} />
                        : <div className="col-md-12">
                            <div className="form-group" id="ma-home-club">
                                <label>Home Club:</label>
                                <div>
                                    {Object.keys(courses).map((course, i) => {
                                    return <label key={course} className="radio-inline">
                                        <input type="radio"
                                        name="member[home_club]"
                                        className="js-home-club form-control"
                                        id={"home_club_" + course}
                                        value={course}
                                        required={i == 0 ? true : false} />
                                        {courses[course]}
                                    </label>
                                    })}
                                </div>
                            </div>
                        </div>}
                    <div className="col-md-12">
                        <div className="form-group" id="ma-existing-member">
                            <label>Are you an existing member?</label>
                            <div>
                                <label className="radio-inline">
                                    <input type="radio"
                                        name="member[existing_member]"
                                        className="js-existing-member form-control"
                                        value='1'
                                        required={true}
                                        />
                                    Yes
                                </label>
                                <label className="radio-inline">
                                    <input type="radio"
                                        name="member[existing_member]"
                                        className="js-existing-member form-control"
                                        value='0'
                                        required={true}
                                        />
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            
            <div className={renewal ? 'hidden-block' : '' } id="ma-charging-account">
                <div className="form-group form-group-wrap">
                    <label>Would you like to apply for a Club Charging Account?</label>
                    <div>
                        <label className="radio-inline">
                            <input type="radio" name="member[has_charging_account]" className="js-has-charging-account" id="charging_account_yes" value="1" data-required required /> Yes
                        </label>
                        <label className="radio-inline">
                            <input type="radio" name="member[has_charging_account]" className="js-has-charging-account" id="charging_account_no" value="0" /> No
                        </label>
                    </div>
                </div>
            </div>

            <div className="hidden-block" id="ma-sold-out">
                <h3 className="text-center"><strong>Sorry, membership is all sold out!</strong></h3>
            </div>

            <div className="hidden-block" id="ma-ez-pay">
                <div className="form-group">
                    <label>
                        Would like to be enrolled in Member Auto Pay?
                    </label>
                    <div>
                        <label className="radio-inline">
                            <input type="radio" name="uses_ez_pay" id="ez_pay_yes" value="1" data-required /> Yes
                        </label>
                        <label className="radio-inline">
                            <input type="radio" name="uses_ez_pay" id="ez_pay_no" value="0" /> No
                        </label>
                    </div>
                </div>
                <div className="form-group">Auto Pay automatically charges the credit card on file on or about the 15th of each month.</div>
            </div>

            <div className={renewal ? 'hidden-block' : ''} id="ma-additional">
                <div className="form-group form-group-lg-radio form-group-with-hint hide-on-plan-biz">
                    <label>Would you like to add your spouse or child?</label>
                    <div>
                        <label className="radio-inline">
                            <input type="radio" name="has_additional" className="js-has-additional" id="additional_yes" value="1" data-required /> Yes
                        </label>
                        <label className="radio-inline">
                            <input type="radio" name="has_additional" className="js-has-additional" id="additional_no" value="0" /> No
                        </label>
                    </div>
                </div>
                <div className="form-group form-group-lg-radio hidden-block" id="ma-additional-access-option">
                    <label>Which Family Access Option would you like to add on?</label>
                    <div>
                        <label className="radio-inline">
                            <input type="radio" name="additional_access_option" className="js-additional-access-option" value="option_1" data-required /> Option 1: $3,059.63
                        </label>
                        <label className="radio-inline">
                            <input type="radio" name="additional_access_option" className="js-additional-access-option" value="option_2" data-required /> Option 2: $1,019.88
                        </label>
                        <label className="radio-inline">
                            <input type="radio" name="additional_access_option" className="js-additional-access-option" value="option_3" data-required /> Option 3: No Membership Fee
                        </label>
                    </div>
                </div>
                <div className="form-group form-group-lg-radio show-on-plan-biz">
                    <label>Please list all the members:</label>
                </div>
                <fieldset className="show-on-plan-biz hidden-block" id="ma-additional-info">
                    <table className="table table-condensed additionals-table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Email</th>
                                {show_dob || is_business_plan ?
                                <th>
                                    {show_dob ?
                                        <span className="hide-on-plan-biz">Date of Birth</span>
                                    : null}
                                    <span className="show-on-plan-biz">Phone</span>
                                </th>
                                : null}
                                <th>
                                <span className="hide-on-plan-biz">Relationship</span>
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="additionals-row" data-id="0">
                                <td><span className="additional-id"></span></td>
                                <td>
                                    <div className="form-group no-flex show-on-plan-biz">
                                        <label htmlFor="additionals_name_0">Name:</label>
                                        <div className="form-control-wrapper">
                                            <input type="text" className="form-control adt-name" name="additionals[0][name]" id="additionals_name_0" data-disabled />
                                        </div>
                                    </div>
                                    <div className="form-group no-flex hide-on-plan-biz">
                                        <label htmlFor="additionals_name_0">Name:</label>
                                        <div className="form-control-wrapper">
                                            <input type="text" className="form-control adt-name" name="additionals[0][name]" id="additionals_name_0" data-required data-disabled />
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div className="form-group no-flex show-on-plan-biz">
                                        <label htmlFor="additionals_email_0">Email:</label>
                                        <div className="form-control-wrapper">
                                            <input type="email" className="form-control adt-email" name="additionals[0][email]" id="additionals_email_0" data-disabled />
                                        </div>
                                    </div>
                                    <div className="form-group no-flex hide-on-plan-biz">
                                        <label htmlFor="additionals_email_0">Email:</label>
                                        <div className="form-control-wrapper">
                                            <input type="email" className="form-control adt-email" name="additionals[0][email]" id="additionals_email_0" data-required data-disabled />
                                        </div>
                                    </div>
                                </td>
                                {show_dob || is_business_plan ?
                                <td>
                                    <div className="form-group no-flex show-on-plan-biz">
                                        <label htmlFor="additionals_phone_0">Phone:</label>
                                        <div className="form-control-wrapper">
                                            <input type="tel" className="form-control phone_us" name="additionals[0][phone]" id="additionals_phone_0" data-disabled />
                                        </div>
                                    </div>
                                    {show_dob ?
                                    <div className="form-group no-flex hide-on-plan-biz">
                                        <label htmlFor="additionals_birthday_month_0">Date of Birth:</label>
                                        <div className="flex">
                                            <div className="form-control-wrapper">
                                                <select className="form-control adt-birthday-month" name="additionals[0][birthday][month]" id="additionals_birthday_month_0" placeholder="Month" data-required data-disabled>
                                                    <option value="">Month</option>
                                                    {Array(12).fill().map((_, i) => {
                                                      return <option key={i} value={i+1}>{i+1}</option>
                                                    })}
                                                </select>
                                            </div>
                                            <label>/</label>
                                            <div className="form-control-wrapper">
                                                <select className="form-control adt-birthday-day" name="additionals[0][birthday][day]" id="additionals_birthday_day_0" placeholder="Day" data-required data-disabled>
                                                  <option value="">Day</option>
                                                  {Array(31).fill().map((_, i) => {
                                                    return <option key={i} value={i+1}>{i+1}</option>
                                                  })};
                                                </select>
                                            </div>
                                            <label>/</label>
                                            <div className="form-control-wrapper">
                                                <select className="form-control adt-birthday-year" name="additionals[0][birthday][year]" id="additionals_birthday_year_0" placeholder="Year" data-required data-disabled>
                                                    <option value="">Year</option>
                                                    {Array(100).fill().map((_, i) => {
                                                      return <option key={i} value={i-20-year}>{i-20-year}</option>
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                                </td>
                                : null}
                                <td>
                                    <div className="form-group no-flex hide-on-plan-biz">
                                        <label htmlFor="additionals_relationship_0">Relationship:</label>
                                        <div className="form-control-wrapper">
                                            <select className="form-control adt-relationship" name="additionals[0][relationship]" id="additionals_relationship_0" placeholder="Relationship" data-required data-disabled>
                                                <option value="">Relationship</option>
                                                <option value="child">Child</option>
                                                <option value="spouse">Spouse</option>
                                            </select>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <button type="button" className="button button-danger button-xsmall hide-on-plan-biz js-remove-additional" data-id="0" aria-label="Remove">
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="text-center">
                        <button type="button" className="button button-outline-primary button-small hide-on-plan-biz js-add-additional">Add +</button>
                        <button type="button" className="button button-outline-primary button-small show-on-plan-biz js-add-additional-members" data-qty="8" data-price="1050">Add 8 members for $1,050</button>
                        <button type="button" className="button button-outline-primary button-small show-on-plan-biz js-add-additional-members" data-qty="16" data-price="1900">Add 16 members for $1,900</button>
                        <button type="button" className="button button-outline-danger button-small js-remove-additional-members" style={{display : 'none' }}>Remove additional members</button>
                    </div>
                </fieldset>
            </div>


            {props.allow_cart_pass && <div id="ma-cart-pass">
                <div className="form-group form-group-lg-radio form-group-with-hint">
                    <label>Would you like to include a Cart Pass{!before121 ? " for $1,066.25?" : "?"}</label>
                    <div>
                        {(props.preselected_cart_pass || before121)
                        ? <label className="radio-inline">
                            <input type="radio" name="payment[cart_pass]" className="js-cart-pass" id="cart_pass" value="1" data-required required defaultChecked={true} /> Yes
                        </label>
                        : <label className="radio-inline">
                            <input type="radio" name="payment[cart_pass]" className="js-cart-pass" id="cart_pass" value="1" /> Yes
                        </label>}
                    
                        {!before121 ? 
                        <label className="radio-inline">
                            <input type="radio" name="payment[cart_pass]" className="js-cart-pass" id="cart_pass" value="0" /> No
                        </label> : null}
                    </div>
                    {before121 ? <span>
                        $1,000 VALUE FREE THROUGH 11/30
                    </span> : null}
                </div>
            </div>}


            <div className="form-group form-group-lg-radio">
                <label>How would you like to pay?</label>
                <div>
                    <label className="radio-inline">
                        <input type="radio" name="payment[method]" className="js-payment-method" id="payment_method_check" value="check" defaultChecked={true} required /> Paid in Full By Check
                    </label>
                    {props.allow_monthly_payments && <label className="radio-inline">
                        <input type="radio" name="payment[method]" className="js-payment-method" id="payment_method_monthly" value="monthly" /> 8 Monthly Payments via Auto CC (Inquire with Golf Shop for details)
                    </label>}
                </div>
            </div>
            
            <div id="ma-continue" className="form-actions text-right">
                <div id='recaptcha' className="g-recaptcha"
                    data-sitekey="6LfpdYUUAAAAAIoByh3tvwOpmTNOQXMVwEs4h0X8"
                    data-callback="onSubmitMemberForm"
                    data-size="invisible"></div>

                <button type="button" className="button button-primary button-continue" onClick={props.onSubmit} disabled={renewal && !member_loaded ? 'disabled' : false}>Continue</button>
            </div>
        </div>
      </div>
    </div>
  }
}

export default MemberForm;